import React from 'react';
import { motion } from 'framer-motion';
import { Star, Check, AlertTriangle, XCircle, ScanLine } from 'lucide-react';
export function HeroSection() {
  return <section className="relative pt-32 pb-20 lg:pt-40 lg:pb-28 overflow-hidden" data-id="element-2210" data-mp="2hsq7unt4r3ou">
      {/* Background Elements */}
      <div className="absolute inset-0 -z-10 overflow-hidden" data-id="element-2211" data-mp="28u4st2mva6st">
        <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[1000px] h-[1000px] bg-brand-100/40 rounded-full blur-3xl opacity-50" data-id="element-2212" data-mp="28ueiep402bxz" />
        <div className="absolute top-1/4 right-0 w-[500px] h-[500px] bg-accent-100/40 rounded-full blur-3xl opacity-40" data-id="element-2213" data-mp="30l2hzwq0z99j" />
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-2214" data-mp="2msupwi9os6h6">
        <div className="grid lg:grid-cols-2 gap-12 lg:gap-8 items-center" data-id="element-2215" data-mp="2rsqsqe6ndrv5">
          {/* Text Content */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6
        }} className="text-center lg:text-left" data-id="element-2216" data-mp="3fius29csz5gc">
            <div className="inline-flex items-center px-3 py-1 rounded-full bg-brand-100 text-brand-700 text-sm font-medium mb-6" data-id="element-2217" data-mp="2beyfytctaa5h">
              <span className="flex h-2 w-2 rounded-full bg-brand-500 mr-2 animate-pulse" data-id="element-2218" data-mp="2p6mqis7ewqkc"></span>
              Now available on iOS & Android
            </div>

            <h1 className="text-4xl sm:text-5xl lg:text-6xl font-black text-slate-900 tracking-tight leading-tight mb-6" data-id="element-2219" data-mp="2z2q2eps2g3kh">
              Know What You're <br className="hidden lg:block" data-id="element-2220" data-mp="2u44yaf9p0zqr" />
              <span className="text-transparent bg-clip-text bg-gradient-to-r from-brand-600 to-brand-500" data-id="element-2221" data-mp="384pjtj6zt9ny">
                Really Eating
              </span>
            </h1>

            <p className="text-lg sm:text-xl text-slate-600 mb-8 max-w-2xl mx-auto lg:mx-0 leading-relaxed" data-id="element-2222" data-mp="1dq6jnn9xbi93">
              Scan any packaged food to instantly detect unhealthy ingredients.
              Make smarter choices with AI-powered ingredient analysis.
            </p>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-4 mb-10" data-id="element-2223" data-mp="38vfnl000ei0x">
              <a href="https://apps.apple.com/us/app/intellieats/id6744873855" target="_blank" rel="noopener noreferrer" className="w-full sm:w-auto" data-id="element-2224" data-mp="3du8ycknwvuxe">
                <button className="w-full sm:w-auto flex items-center justify-center px-6 py-3.5 bg-slate-900 text-white rounded-xl hover:bg-slate-800 transition-all hover:scale-105 duration-200 shadow-xl" data-id="element-2225" data-mp="3rsyyk9612apz">
                  <svg className="w-6 h-6 mr-3" viewBox="0 0 24 24" fill="currentColor" data-id="element-2226" data-mp="5ccn58hhg25a">
                    <path d="M18.71 19.5c-.83 1.24-1.71 2.45-3.05 2.47-1.34.03-1.77-.79-3.29-.79-1.53 0-2 .77-3.27.82-1.31.05-2.3-1.23-3.14-2.47-1.72-2.5-3.03-7.11-1.27-10.13 0.86-1.49 2.4-2.43 4.09-2.46 1.3-.03 2.52.87 3.3.87.78 0 2.25-1.09 3.8-0.92 0.65.03 2.46.26 3.63 1.98-3.24 1.94-2.71 5.99 0.44 7.32-0.67 1.69-1.6 3.35-2.24 4.31zM13 3.5c.73-.83 1.21-1.96 1.08-3.11-1.05.04-2.31.69-3.06 1.57-.68.8-1.27 2.07-1.11 3.17 1.18.09 2.38-.79 3.09-1.63z" data-id="element-2227" data-mp="edao1hwmjtjn" />
                  </svg>
                  <div className="text-left" data-id="element-2228" data-mp="1uvue3054erdn">
                    <div className="text-[10px] uppercase font-medium opacity-80" data-id="element-2229" data-mp="1pvf1wbwkrpx9">
                      Download on the
                    </div>
                    <div className="text-sm font-bold leading-none" data-id="element-2230" data-mp="2mn0e7gkucp2x">
                      App Store
                    </div>
                  </div>
                </button>
              </a>

              <a href="https://play.google.com/store/apps/details?id=com.Lakh.intelli_eats&pcampaignid=web_share" target="_blank" rel="noopener noreferrer" className="w-full sm:w-auto" data-id="element-2231" data-mp="2dqrj2e3wccml">
                <button className="w-full sm:w-auto flex items-center justify-center px-6 py-3.5 bg-white text-slate-900 border border-slate-200 rounded-xl hover:bg-slate-50 transition-all hover:scale-105 duration-200 shadow-lg" data-id="element-2232" data-mp="31h59k06u23f2">
                  <svg className="w-6 h-6 mr-3 text-slate-900" viewBox="0 0 24 24" fill="currentColor" data-id="element-2233" data-mp="2q31zml9nlqec">
                    <path d="M3,20.5V3.5C3,2.91,3.34,2.39,3.84,2.15L13.69,12L3.84,21.85C3.34,21.6,3,21.09,3,20.5M16.81,15.12L6.05,21.34L14.54,12.85L16.81,15.12M20.16,10.81C20.5,11.08,20.75,11.5,20.75,12C20.75,12.5,20.5,12.92,20.16,13.19L17.89,14.5L15.39,12L17.89,9.5L20.16,10.81M6.05,2.66L16.81,8.88L14.54,11.15L6.05,2.66Z" data-id="element-2234" data-mp="2h1lzd6cjz4nu" />
                  </svg>
                  <div className="text-left" data-id="element-2235" data-mp="2zzoix5mc09e9">
                    <div className="text-[10px] uppercase font-medium opacity-80" data-id="element-2236" data-mp="2zyn3yq2732r9">
                      Get it on
                    </div>
                    <div className="text-sm font-bold leading-none" data-id="element-2237" data-mp="3sg8yesnozmpi">
                      Google Play
                    </div>
                  </div>
                </button>
              </a>
            </div>

            <div className="flex items-center justify-center lg:justify-start space-x-8 text-sm font-medium text-slate-500" data-id="element-2238" data-mp="1obf5ba6nyws">
              <div className="flex items-center" data-id="element-2239" data-mp="feewbnu7h2fd">
                <div className="flex text-accent-500 mr-2" data-id="element-2240" data-mp="fhavffhshx5e">
                  {[...Array(5)].map((_, i) => <Star key={i} className="w-4 h-4 fill-current" data-id="element-2241" data-mp="3iw6w3oel2qo4" data-mpi={i} />)}
                </div>
                <span data-id="element-2242" data-mp="3euv2l7sl9lan">5.0 Rating</span>
              </div>
              <div className="w-px h-4 bg-slate-300" data-id="element-2243" data-mp="3ewegwsuopm9s"></div>
              <div data-id="element-2244" data-mp="3summ1o1vjtw1">Free Ingredient Scanner</div>
              <div className="w-px h-4 bg-slate-300" data-id="element-2245" data-mp="3ss9x2qxp8j9h"></div>
              <div data-id="element-2246" data-mp="3nu8bnzcsw7uu">1k+ Scans</div>
            </div>
          </motion.div>

          {/* Phone Mockup */}
          <motion.div initial={{
          opacity: 0,
          scale: 0.9
        }} animate={{
          opacity: 1,
          scale: 1
        }} transition={{
          duration: 0.8,
          delay: 0.2
        }} className="relative mx-auto lg:mr-0 max-w-[320px] lg:max-w-[360px]" data-id="element-2247" data-mp="182u9e4ts1ao2">
            {/* Floating Elements */}
            <motion.div animate={{
            y: [0, -15, 0]
          }} transition={{
            duration: 4,
            repeat: Infinity,
            ease: 'easeInOut'
          }} className="absolute -right-8 top-20 z-20 bg-white p-3 rounded-2xl shadow-xl border border-slate-100 hidden sm:block" data-id="element-2248" data-mp="1k783h3q79a8d">
              <div className="flex items-center gap-3" data-id="element-2249" data-mp="11ecjl1dt5mkq">
                <div className="bg-red-100 p-2 rounded-full" data-id="element-2250" data-mp="1675njn1gcqvr">
                  <XCircle className="w-5 h-5 text-red-600" data-id="element-2251" data-mp="168qdt0gqhnnt" />
                </div>
                <div data-id="element-2252" data-mp="8qzuokk6d2o9">
                  <div className="text-xs text-slate-500 font-medium" data-id="element-2253" data-mp="8pf93kfu8u2j">
                    Detected
                  </div>
                  <div className="text-sm font-bold text-slate-900" data-id="element-2254" data-mp="67d9fvt1c4ms">Red 40</div>
                </div>
              </div>
            </motion.div>

            <motion.div animate={{
            y: [0, 15, 0]
          }} transition={{
            duration: 5,
            repeat: Infinity,
            ease: 'easeInOut',
            delay: 1
          }} className="absolute -left-8 bottom-32 z-20 bg-white p-3 rounded-2xl shadow-xl border border-slate-100 hidden sm:block" data-id="element-2255" data-mp="18a2u6xepqcp">
              <div className="flex items-center gap-3" data-id="element-2256" data-mp="3ekk6pdr45c5s">
                <div className="bg-brand-100 p-2 rounded-full" data-id="element-2257" data-mp="39olpca47cuev">
                  <Check className="w-5 h-5 text-brand-600" data-id="element-2258" data-mp="34oh98l77i1p6" />
                </div>
                <div data-id="element-2259" data-mp="34mmkevstdpft">
                  <div className="text-xs text-slate-500 font-medium" data-id="element-2260" data-mp="2zp4jnsoyagiw">Safe</div>
                  <div className="text-sm font-bold text-slate-900" data-id="element-2261" data-mp="2zr77q76jlzkz">
                    Natural Flavors
                  </div>
                </div>
              </div>
            </motion.div>

            {/* Phone Frame with Real Screenshot */}
            <div className="relative z-10 bg-slate-900 rounded-[3rem] p-3 shadow-2xl ring-1 ring-slate-900/5" data-id="element-2262" data-mp="sd4kzaao13js">
              <div className="absolute top-0 left-1/2 -translate-x-1/2 h-6 w-32 bg-slate-900 rounded-b-2xl z-20" data-id="element-2263" data-mp="dg3t96sh58lb"></div>
              <div className="bg-white rounded-[2.5rem] overflow-hidden h-[640px] w-full relative" data-id="element-2264" data-mp="ie5d3txq5bxu">
                <img src="https://cdn.magicpatterns.com/uploads/rEv5VJjByxFRFVxawWAVNC/WhatsApp_Image_2026-03-16_at_14.19.17.jpg" alt="IntelliEats app showing scan results with ingredients to avoid and limited intake categories" className="w-full h-full object-cover object-top" data-id="element-2265" data-mp="4na7cqiivayh" />
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}